import { cn } from '@/shared/utils/cn';
import type { StoreFeatureSectionData } from '../data/storeFeatureSections.data';
import { StoreFeatureCard } from './StoreFeatureCard';

type StoreFeatureSectionProps = {
  section: StoreFeatureSectionData;
};

const SECTION_CLASS: Record<StoreFeatureSectionData['variant'], string> = {
  special: 'bg-gradient-to-b from-white to-[#fceaee]',
  promise: 'bg-gradient-to-b from-white to-[#d1f5fb]',
};

export function StoreFeatureSection({ section }: StoreFeatureSectionProps) {
  return (
    <section className={cn('w-full opacity-80', SECTION_CLASS[section.variant])}>
      <div className="mx-auto max-w-6xl px-4 pb-10 pt-12 md:px-6 md:pb-16 md:pt-[70px]">
        <h2 className="mb-6 text-center font-serif text-2xl leading-[30px] text-[#001e38] md:mb-10">
          {section.title}
        </h2>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-[22px]">
          {section.items.map((item) => (
            <StoreFeatureCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}
